import React, { useRef, useEffect, useState } from "react";

export default function VideoPlayer({
  videoSrc,
  placeholder,
  onTimeWatchedFunction,
  onTimeWatchedFunctionTriger,
  setSecondsWatched,
  secondsWatched,
  controlList = "nodownload",
}) {
  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;

    const handleTimeUpdate = () => {
      if (
        videoElement.currentTime >= onTimeWatchedFunctionTriger &&
        !secondsWatched
      ) {
        setSecondsWatched(true);
        onTimeWatchedFunction();
      }
    };

    if (videoElement) {
      videoElement.addEventListener("timeupdate", handleTimeUpdate);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("timeupdate", handleTimeUpdate);
      }
    };
  }, [secondsWatched, onTimeWatchedFunction]);

  return (
    <div className="video-player">
      <video
        ref={videoRef}
        key={videoSrc}
        controls={true}
        autoPlay={false}
        controlsList={controlList}
        name="media"
        poster={placeholder ? placeholder : null}
      >
        <source src={videoSrc} type="video/mp4" />
      </video>
    </div>
  );
}
